module.exports = __webpack_public_path__ + "static/media/Jayesh.36d6df96.jpeg";